<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">
                
            </div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card-body p-2" *ngIf="dropDownOptions && dropdownValue">
                <ng-select [items]="dropDownOptions" [addTag]="true" [multiple]="true" [selectOnTab]="true"
                    placeholder="Type in to save"  [(ngModel)]="dropdownValue">
                </ng-select>
            </div>
            <!--  -->
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button>
            <button class="btn btn-primary mx-2 text-white" (click)="updateInfo()">
                Save
            </button>
        </div>
    </div>
</section>